import axios from 'axios';

import config from '../common/config';
export default {
  fetchSearchAccommodationsByLocation(token, lat, lng, isRideManager = false) {
    const url = isRideManager 
      ? `${config.config.ROOT_URL}/serch_accommodations_by_location_api/${lat}/${lng}?is_ride_manager=true`
      : `${config.config.ROOT_URL}/serch_accommodations_by_location_api/${lat}/${lng}`;
    
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },

};
